import React from "react";
import apiAgent from "../../../app/api/apiAgent";
import { OMSButtonStyleL } from "../../../app/common/common-components/OMSButton";
import { DataTableCompDynamicT } from "../../../app/common/common-components/OMSDatatables";
import { OMSDropdown } from "../../../app/common/common-components/OMSDropdown";
import { OMSMultiselectPTDropdown } from "../../../app/common/common-components/OMSMultiselectTagDropdown";
import { OMSTwitterAutocomplete2 } from "../../../app/common/common-components/OMSAutocomplete";
import moment from "moment";
import { FromDateStringToJavascriptDate, FromJavascriptDateToDateString } from "../../../app/common/common-functions/functions";
import DatePicker from "react-datepicker";
import { withRouter } from 'react-router-dom';

class TaskGrid extends React.Component {
  constructor(props) {
    super(props);
    this.reportGridRef = React.createRef();
  }

  loadGrid = (requestParams) => {

    var ViewData = this.state.ViewData;

    return apiAgent.Deal.taskDynamicAjax(
      requestParams,
      "",
      "",
      "",
      ViewData.PropertyTypes.join(","),
      ViewData.Agent,
      "",
      "",
      "",
      ViewData.Areas,
      ViewData.NeedUpdate,
      this.state.mPage,
      this.state.mSearch,
      ViewData.Pipeline,
      ViewData.PipelineId,
      ViewData.ExpectedRegistrationStartDate,
      ViewData.ExpectedRegistrationEndDate
    );
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleDropdownChange = (e) => {
    if (e.name == "mAgent") {
      var mAgentName = window.$("#mAgent option:selected").text();
      this.setState({ [e.name]: e.newValue, mAgentName: mAgentName });
    } else if (e.name == "mOfficeID") {
      var mOfficeID = e.newValue;
      var mOfficeName = window.$("#mOfficeID option:selected").text();
      this.onOfficeIDAgentsChanged(mOfficeID, mOfficeName);
    } else if (e.name == "mPipeline") {
      if(e.newValue != ""){
        this.setState({ mPipeline: e.newText, mPipelineId: e.newValue });
      }
      else{
        this.setState({ mPipeline: "", mPipelineId: ""});
      }

    } else {
      this.setState({ [e.name]: e.newValue });
    }
  };

  handlePropertyTypesChange = (selected) => {
    this.setState({ mPropertyTypes: selected });
  };

  componentDidMount() { }

  onCreateClick = (e) => {
    // window.location.href = "/Property/SaveProperty";
  };

  handleRowClick = (data) => {
    // window.location.href = "/Deal/saveDeal?ID=" + data.dealID;
    this.props.history.push('/Deal/saveDeal?ID='+ data.dealId);
  };

  onOpenFilterClick = (e) => {
    var mViewData = this.state.ViewData;
    this.setState({
      mPropertyTypes: [...mViewData.PropertyTypes],
      mAgent: mViewData.Agent,
      mAgentName: mViewData.AgentName,
      mPipeline: mViewData.Pipeline,
      mPipelineId: mViewData.PipelineId,
      mRegistrationEndTo: mViewData.ExpectedRegistrationEndDate ? mViewData.ExpectedRegistrationEndDate : "",
      mRegistrationStartFrom: mViewData.ExpectedRegistrationStartDate ? mViewData.ExpectedRegistrationStartDate : "",
      mRegistrationEndToDT: FromDateStringToJavascriptDate(mViewData.ExpectedRegistrationEndDate),
      mRegistrationStartFromDT: FromDateStringToJavascriptDate(mViewData.ExpectedRegistrationStartDate),
      mAreas:[...mViewData.Areas],
    });
    window.$("#filterModel").modal("show");
  };

  onApplyFilterClick = (e) => {
    window.$("#filterModel").modal("hide");
    var filterData = this.state.ViewData;
    filterData.Agent = this.state.mAgent;
    filterData.AgentName = this.state.mAgentName;
    filterData.NeedUpdate = true;
    filterData.Areas = [...this.state.mAreas];
    filterData.Pipeline = this.state.mPipeline;
    filterData.PipelineId = this.state.mPipelineId;
    filterData.ExpectedRegistrationStartDate = this.state.mRegistrationStartFrom;
    filterData.ExpectedRegistrationEndDate = this.state.mRegistrationEndTo;
    filterData.PropertyTypes = [...this.state.mPropertyTypes];

    this.setState({ ViewData: filterData, ExtraParams: JSON.stringify(filterData) });
  };

  onResetFilterClick = (e) => {
    window.$("#filterModel").modal("hide");
    var filterData = this.getDefaultViewData(null);
    filterData.NeedUpdate = true;
    this.setState({ ViewData: filterData, ExtraParams: JSON.stringify(filterData) });
  };


  onOfficeIDAgentsChanged = (mOfficeID, mOfficeName) => {
    if (this.state.mOfficeID != mOfficeID) {
      apiAgent.Property.getAgentsDDAjax(mOfficeID)
        .then((response) => {
          this.setState({
            mAgent: "",
            mAgentName: "",
            //Agents: JSON.parse(response),
            Agents: JSON.parse(JSON.stringify(response)),
            mOfficeID: mOfficeID,
            mOfficeName: mOfficeName,
          });
        })
        .catch((error) => {
          //toast.error(error.response.data))
        });
    } else {
      this.setState({ mOfficeID: mOfficeID, mOfficeName: mOfficeName });
    }
  };

  getDefaultViewData = (data) => {
    console.log("getDefaultViewData");
    console.log(data);
    var PropertyTypes = [];
    var Agent = "";
    var Pipeline = "";
    var PipelineId = "";
    var AgentName = "";
    var Areas = [];
    var ExpectedRegistrationEndDate = "";
    var ExpectedRegistrationStartDate = "";

    if (data != null) {
      Agent = data.Agent;
      AgentName = "";
      Pipeline = data.Pipeline;
      PipelineId = data.PipelineId ?? "";
      Areas = data.Areas;
      if (data.PropertyType)
        PropertyTypes = data.PropertyType.split(',');
      ExpectedRegistrationEndDate = data.ExpectedRegistrationEndDate;
      ExpectedRegistrationStartDate = data.ExpectedRegistrationStartDate;

      if (data.Agent !== undefined && data.Agent != null && data.Agent != "") {
        for (var i = 0; i < this.props.Agents.length; i++) {
          if (this.props.Agents[i].Value == Agent) {
            AgentName = this.props.Agents[i].Text;
          }
        }
      }

    }

    return {
      NeedUpdate: false,
      PropertyTypes,
      Agent,
      Pipeline,
      PipelineId,
      AgentName,
      Areas,
      ExpectedRegistrationStartDate,
      ExpectedRegistrationEndDate,
    };
  };

  formatDate = (fullDateString) => {
    const date = new Date(fullDateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear());

    return `${day}-${month}-${year}`;
  };

  getDisplayText = (data) => {
    var filterText = "";

    if (data.Pipeline) {
      filterText = data.Pipeline + " | ";
    }

    if (data.PropertyTypes != "Property Type" && data.PropertyTypes != "") filterText = filterText + data.PropertyTypes + " | ";

    if (data.Agent) filterText = filterText + data.AgentName + " | ";

    if (data.Areas.length > 0) {
      if (data.Areas.length == 1) filterText = filterText + data.Areas[0] + " | ";
      else filterText = filterText + "Area(s) | ";
    }
    if (data.ExpectedRegistrationStartDate && data.ExpectedRegistrationEndDate) {
      filterText = filterText + "Registration start between " + data.ExpectedRegistrationStartDate + " to " + data.ExpectedRegistrationEndDate + " | ";
    } else if (data.ExpectedRegistrationStartDate) {
      filterText = filterText + "Registration start from " + data.ExpectedRegistrationStartDate + " | ";
    } else if (data.ExpectedRegistrationEndDate) {
      filterText = filterText + "Registration start upto " + data.ExpectedRegistrationEndDate + " | ";
    }
    if (filterText != "") filterText = filterText.slice(0, filterText.length - 3);

    return filterText;
  };

  areaSelectionChanged = (e) => {
    var selectedArea = e.suburb == "" ? e.town : e.town + ", " + e.suburb;
    if (this.state.mAreas.indexOf(selectedArea) == -1) {
      var pSelectedAreas = this.state.mAreas;
      pSelectedAreas.push(selectedArea);
      this.setState({ mAreas: pSelectedAreas });
    }
  };

  areaSelectionRemoved = (e) => {
    var index = this.state.mAreas.indexOf(e);
    if (index > -1) {
      var pSelectedAreas = this.state.mAreas;
      pSelectedAreas.splice(index, 1);
      this.setState({ mAreas: pSelectedAreas });
    }
  };

  state = {
    loading: false,
    ViewData: this.getDefaultViewData(this.props.FilterCache),
    ExtraParams: JSON.stringify(this.getDefaultViewData(this.props.FilterCache)),
    mPage: "",
    mSearch: "",
    mPropertyTypes: [],
    mAgent: "",
    mAgentName: "",
    mPipeline: "",
    mPipelineId: "",
    mAreas: [],
    mRegistrationStartFrom: "",
    mRegistrationEndTo: "",
    mRegistrationStartFromDT: null,
    mRegistrationEndToDT: null,
  };

  render() {
    var self = this;
    var filterText = this.getDisplayText(this.state.ViewData);

    return (
      <div className="row mt-2">
        <div className="col-md-11 col-sm-12">
          <div className="panel panel-default panel-table oms-box">
            <div className="panel-heading">
              <div className="row">
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-inline form-group">
                    <div className="element">
                      <div className="truncate">
                        <label>
                          <i className="fa fa-filter" aria-hidden="true"></i>
                          &nbsp;
                        </label>
                        <a className="filter-text" onClick={this.onOpenFilterClick}>
                          {filterText == "" ? (
                            "Select filter"
                          ) : (
                            <span>
                              <b>Filter: </b>
                              {filterText}
                            </span>
                          )}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="pull-right boxRightMenu">
                    <div className="form-inline">
                      {/* <OMSButtonStyleL
                        type="button"
                        ui_icon=""
                        ui_type="create"
                        ui_text="add Deal"
                        ui_processing_text=""
                        processing={false}
                        disabled={false}
                        onClick={this.onCreateClick}
                      /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="panel-body">
              <div>
                <DataTableCompDynamicT id="dealTable" onRowClick={this.handleRowClick} makeAjaxRequest={this.loadGrid} ExtraParams={this.state.ExtraParams} />
              </div>
            </div>
          </div>
          <div className="modal fade" id="filterModel" tabIndex={-1} aria-labelledby="filterModelLabel" aria-hidden="true">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
                    ×
                  </button>
                  <h4 className="modal-title" id="filterModelLabel">
                    Filter
                  </h4>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="form-group">
                      <div className="col-md-4 col-sm-6 col-xs-12 marginBottom10">
                        <OMSMultiselectPTDropdown
                          id="mPropertyTypes"
                          selected={this.state.mPropertyTypes}
                          data={this.props.PropertyTypes}
                          onChange={this.handlePropertyTypesChange}
                          labelField="Property Type(s)"
                        ></OMSMultiselectPTDropdown>
                      </div>
                      <div className="col-md-4 col-sm-6 col-xs-12 marginBottom10">
                        <OMSDropdown
                          id="mAgent"
                          name="mAgent"
                          style={{ marginRight: 10 }}
                          options={this.props.Agents}
                          valueField="Value"
                          labelField="Text"
                          value={this.state.mAgent}
                          onChange={this.handleDropdownChange}
                        />
                      </div>
                      <div className="col-md-4 col-sm-6 col-xs-12 marginBottom10">
                        {/* {this.props.ShowOfficeDD ? (
                          <OMSDropdown
                            id="mOfficeID"
                            name="mOfficeID"
                            options={this.props.OfficeDD}
                            style={{ marginRight: 10 }}
                            valueField="Value"
                            labelField="Text"
                            value={this.state.mOfficeID}
                            onChange={this.handleDropdownChange}
                          />
                        ) : null} */}
                        <OMSDropdown
                          id="mPipeline"
                          name="mPipeline"
                          options={this.props.pipelineDD}
                          style={{ marginRight: 10 }}
                          valueField="Value"
                          labelField="Text"
                          value={this.state.mPipelineId}
                          onChange={this.handleDropdownChange}
                        />
                      </div>
                    </div>
                    <div className="hidden-xs hidden-sm">
                      <br />
                      <br />
                    </div>
                    <div className="form-group">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="row">
                          <div className="col-md-12 col-sm-12 col-xs-12">
                            <label>Expected registration between</label>
                          </div>
                          <div className="col-md-4 col-sm-6 col-xs-12 marginBottom10">
                              <DatePicker
                                selected={this.state.mRegistrationStartFromDT}
                                onChange={(date) => {
                                  this.setState({ mRegistrationStartFromDT: date, mRegistrationStartFrom: FromJavascriptDateToDateString(date) });
                                }}
                                dateFormat="dd-MM-yyyy"
                                value={this.state.mRegistrationStartFromDT}
                                placeholderText="Registration from"
                                name="mRegistrationStartFrom"
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                style={{ width: 150 }}
                                className="form-control MandateDatePicker2"
                              />
                            </div>
                            <div className="col-md-4 col-sm-6 col-xs-12 marginBottom10">
                              <DatePicker
                                selected={this.state.mRegistrationEndToDT}
                                onChange={(date) => {
                                  this.setState({ mRegistrationEndToDT: date, mRegistrationEndTo: FromJavascriptDateToDateString(date) });
                                }}
                                dateFormat="dd-MM-yyyy"
                                value={this.state.mRegistrationEndToDT}
                                placeholderText="Registration to"
                                name="mRegistrationEndTo"
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                style={{ width: 150 }}
                                className="form-control MandateDatePicker2"
                              />
                            </div>
                        </div>
                        <div className="hidden-xs hidden-sm">
                          <br />
                        </div>
                      </div>
                    </div>
                    <div className="hidden-xs hidden-sm">
                      <br />
                      <br />
                    </div>
                    <div className="form-group">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <label>Area(s)</label>
                        <OMSTwitterAutocomplete2 id="SelectedAreas" name="SelectedAreas" value="" onSelect={this.areaSelectionChanged} />
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="search-bar" style={{ marginTop: 10, marginBottom: 15 }}>
                          {this.state.mAreas.length == 0 ? null : (
                            <div className="search-bar__container">
                              <div className="search-bar__autocomplete">
                                <div className="search-bar__autocomplete-input">
                                  {this.state.mAreas.map(function (e, index) {
                                    return (
                                      <div key={index} className="search-bar__autocomplete-selected">
                                        {e}{" "}
                                        <i
                                          onClick={() => self.areaSelectionRemoved(e)}
                                          style={{ fontSize: 18, cursor: "pointer", margin: 2, marginRight: 10 }}
                                          className="fa fa-trash"
                                        ></i>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <a href="#" style={{ marginRight: 5 }} onClick={this.onResetFilterClick}>
                    Reset
                  </a>
                  <button type="button" className="btn btn-primary" onClick={this.onApplyFilterClick}>
                    Apply
                  </button>
                  <button type="button" className="btn btn-default" data-dismiss="modal">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(TaskGrid);